import { ITeamTypings, PlayerTypings } from '@sky-it-livedata/livedata-sports-design-system';
import { IGenericObject } from '../tests';
import { formationVariantsType, IFormationPlayer, transformFormationPlayer } from './formation-players';
import { LmpPredictedLineupDetailsTeam, PredictedLineupPlayerList, PredictedLineupTeam } from 'appsync';

export type Orientation = 'vertical' | 'horizontal';

export interface IMatchFormationField {
  readonly debug?: boolean;
  readonly formation: IGenericObject | '';
  readonly players: ReadonlyArray<IFormationPlayer>;
  readonly customFormationSchema?: readonly IGenericObject[];
  readonly hasImage?: boolean;
  readonly orientation?: Orientation;
}

const getFormationRoles = (teamLineup: IGenericObject, remapped: boolean, variant?: formationVariantsType): ReadonlyArray<IFormationPlayer> | undefined =>
  teamLineup?.playerList?.startingLineup?.map((player: IGenericObject) => {
    const {fallbackImageUrl, ...rest} = transformFormationPlayer(player, teamLineup.formation, variant, remapped);

    return variant === "LMP" ? rest : { ...rest, fallbackImageUrl };
  });

export const transformFormationFields = (matchLineups: IGenericObject, remapped: boolean, variant?: formationVariantsType): IGenericObject => {
  const homeLineup: IGenericObject = matchLineups?.home;
  const awayLineup: IGenericObject = matchLineups?.away;

  if (homeLineup && awayLineup) {
    const homeFormation: IMatchFormationField = {
      formation: homeLineup.formation,
      players: getFormationRoles(homeLineup, remapped, variant) || [],
      hasImage: false,
    };
    const awayFormation: IMatchFormationField = {
      formation: awayLineup.formation,
      players: getFormationRoles(awayLineup, remapped, variant) || [],
      hasImage: false,
    };

    const transformedFormationsLineups = {
      home: homeFormation,
      away: awayFormation,
    };

    return transformedFormationsLineups;
  }

  return {
    home: {},
    away: {},
  };
};

export const stringToObjectArray = (fullName: string, _isArray: boolean = true) => {
  const player: PlayerTypings.IPlayer = {
    id: null,
    role: null,
    fullName,
  };

  return player;
};

export const transformTeam = (team: PredictedLineupTeam | LmpPredictedLineupDetailsTeam): ITeamTypings => {
  const { playerList } = team;
  const { disqualifiedPlayers, manager, potentialPlayers, substitutePlayers, unavailablePlayers, predictedLineup } =
    playerList as PredictedLineupPlayerList;
  return {
    ctaUrl: team.predictedTeamLink ?? '',
    formation: team.formation as ITeamTypings['formation'],
    id: team.id,
    logoUrl: team.negativeLogoUrl || team.logo!,
    name: team.customName!,
    seoName: team.customSeoName ?? undefined,
    shortname: team.teamShortName ?? undefined,
    playerList: {
      disqualifieds: [stringToObjectArray(disqualifiedPlayers!)],
      manager: stringToObjectArray(manager!),
      potentialPlayers: [stringToObjectArray(potentialPlayers!)],
      substitutes: [stringToObjectArray(substitutePlayers!)],
      unavailables: [stringToObjectArray(unavailablePlayers!)],
      startingLineup: predictedLineup!.map((item) => ({
        ...item,
        fullName: item!.fullName,
      })) as PlayerTypings.IPlayer[],
    },
  };
};

export const transformPlayerList = (playerList: IGenericObject, variant: formationVariantsType = 'DEFAULT'): IGenericObject => ({
  ...playerList,
  disqualifieds: variant === 'LMP' ? [...playerList.disqualifieds] : stringToObjectArray(playerList.disqualifieds),
  potentialPlayers: variant === 'LMP' ? [...playerList.potentialPlayers] : stringToObjectArray(playerList.potentialPlayers),
  substitutes: variant === 'LMP' ? [...playerList.substitutes] : stringToObjectArray(playerList.substitutes),
  unavailables: variant === 'LMP' ? [...playerList.unavailables] : stringToObjectArray(playerList.unavailables),
  manager: variant === 'LMP' ? { ...playerList.manager, role: "Manager" } : stringToObjectArray(playerList.manager),
});